import * as React from 'react'

import { BaseAcceptInvite } from '../shared'

import { cartAddInvite } from './generated';

export function PrivateEnrollment() {
  return <BaseAcceptInvite title='Invitation to enroll' message="You've been invited to enroll at a school"  mutation={cartAddInvite} onSuccess='/checkout' />
}
